import DriversLicenseGlobalNoFace from './drivers-license-global-no-face';
import NationalIdentityCardGlobalNoFace from './national-identity-card-global-no-face';
import ResidenceCardGlobalNoFace from './residence-card-global-no-face';
import PassportGlobalNoFace from './passport-global-no-face';
import DriversLicenseGlobalFace from './drivers-license-global-face';
import NationalIdentityCardGlobalFace from './national-identity-card-global-face';
import ResidenceCardGlobalFace from './residence-card-global-face';
import PassportGlobalFace from './passport-global-face';
import PhilidGlobalFace from './philid-global-face';
import TinidGlobalFace from './tinid-global-face';
import SssidGlobalFace from './sssid-global-face';
import UmidGlobalFace from './umid-global-face';
import Umid2GlobalFace from './umid2-global-face';

export default {
  'drivers-license-global-no-face': DriversLicenseGlobalNoFace,
  'national-identity-card-global-no-face': NationalIdentityCardGlobalNoFace,
  'residence-card-global-no-face': ResidenceCardGlobalNoFace,
  'passport-global-no-face': PassportGlobalNoFace,
  'drivers-license-global-face': DriversLicenseGlobalFace,
  'national-identity-card-global-face': NationalIdentityCardGlobalFace,
  'residence-card-global-face': ResidenceCardGlobalFace,
  'passport-global-face': PassportGlobalFace,
  'philid-global-face': PhilidGlobalFace,
  'tinid-global-face': TinidGlobalFace,
  'sssid-global-face': SssidGlobalFace,
  'umid-global-face': UmidGlobalFace,
  'umid2-global-face': Umid2GlobalFace
};
